'use client';

import { useTranslations } from "next-intl";
import Image from "next/image";
import { useState } from "react";
import { MdArrowBackIos } from "react-icons/md";
import { useLocale } from "next-intl";
import useFetchPosts from "@/components/post/fetcher";
import FeaturedWork from "@/components/post/FeaturedWork";
import Offer from "@/components/home-page/body/offer";
import ScrollGuideButton from "@/components/home-page/scrollDown";
import Newshop from "@/components/home-page/body/shopLetterOtherPages";
export default function Products() {
  const t = useTranslations('Blog');
  const l = useLocale();
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 28;

  function images() {
    return l == "ar" ? "/blog-hero/حقيبة- تنس- في-الملعب.avif" :
      (l == "de" ? "/blog-hero/tennis-tasche-am-platz.avif" :
        (l == "es" ? "/blog-hero/bolsa-de-tenis-en-la-canchas.avif" :
          (l == "fr" ? "/blog-hero/sac-de-tennis-sur-le-court.avif" :
            (l == "it" ? "/blog-hero/borsa-da-tennis-sul-campo.avif" :
              (l == "nl" ? "/blog-hero/tennis-tas-op-de-baan.avif" :
                (l == "pt" ? "/blog-hero/bolsa-de-tenis-na-pista.avif" :
                  (l == "ru" ? "/blog-hero/tennis-sumka-na-korte.avif" :
                    (l == "sv" ? "/blog-hero/tennisvaska-pa-banan.avif" :
                      "/blog-hero/tennis-bag-at-the-court.avif"
                    )
                  )
                )
              )
            )
          )
        )
      );
  }

  const { posts, error, isLoading } = useFetchPosts();

  const totalPages = Math.ceil(posts.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentItems = posts.slice(startIndex, endIndex);

  const handlePageChange = (page: number) => setCurrentPage(page);
  const handleNext = () => currentPage < totalPages && setCurrentPage(currentPage + 1);
  const handlePrevious = () => currentPage > 1 && setCurrentPage(currentPage - 1);

  const getLocalizedField = (item: any, field: string) => item[`${field}_${l}`] || item[`${field}_en`];

  return (
    <div className="bg-neutral">
      {/* Hero Section */}
      <div className="h-96 w-full sm:col-span-1 relative flex items-center bg-secondary">
        <Image 
          src={images()}
          alt={t('tag')} 
          fill
          sizes="100vw" 
          className="z-0 object-cover" 
          quality={85}  
          priority 
        />
        <div className="absolute inset-0 bg-black bg-opacity-70"></div>
        <div className="absolute sm:bottom-10 mx-5 lg:mx-10 px-1 shadow-lg">
          <h1 className="text-xl md:text-4xl font-bold uppercase text-white mb-8">{t('title')}</h1>
          <p className="max-w-5xl text-white sm:text-lg">{t('description')}</p>
        </div>
      </div> 
      <ScrollGuideButton/>
       {/* Featured Work Section with Animation */}
<div className="lg:px-8">
     <FeaturedWork 
        posts={posts}
        isLoading={isLoading}
        error={error}
        locale={l}
        getLocalizedField={getLocalizedField}
        title={t('Latest News')}
      />

</div>
    
   
      {/* Pagination */}
      {posts.length > itemsPerPage && (
        <div className="w-full px-3 sm:px-5">
          <div className="flex justify-between items-center gap-2 mb-20 mt-10 flex-wrap">
            <button 
              disabled={currentPage === 1} 
              onClick={handlePrevious} 
              className="text-white hover:text-yel flex items-center"
            >
              <MdArrowBackIos className={l === 'ar' ? "rotate-180" : ""} />
              <p className="capitalize font-semibold">{t('previous')}</p>
            </button>

            {/* Page Numbers */}
            <div className="flex gap-2 flex-wrap">
              {Array.from({ length: totalPages }, (_, index) => (
                <button
                  key={index + 1}
                  onClick={() => handlePageChange(index + 1)}
                  className={`px-2 rounded-2xl font-bold opacity-70 ${
                    currentPage === index + 1 
                      ? "bg-yel text-secondary" 
                      : "bg-secondary text-yel hover:bg-yel hover:text-secondary"
                  }`}
                >
                  {index + 1}
                </button>
              ))}
            </div>

            <button 
              disabled={currentPage === totalPages} 
              onClick={handleNext} 
              className="text-white hover:text-yel flex items-center"
            >
              <p className="capitalize font-semibold">{t('next')}</p>
              <MdArrowBackIos className={l === 'ar' ? "" : "rotate-180"} />
            </button>
          </div>
        </div>
      )}
        <Offer/>
        <Newshop/>
           
    </div>
  );
}